module.exports = __webpack_public_path__ + "static/media/info-symbol.f7e80d23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-symbol.svg
// module id = 887
// module chunks = 0